import { useMemo } from 'react';
import type { ValidationResult } from '@mtg-deck-tool/shared';
import { useDeckStore } from '../stores/deck-store.js';
import { validateDeck } from '../lib/validation.js';

export function useValidation(): ValidationResult {
  const entries = useDeckStore((s) => s.entries);
  const colorIdentity = useDeckStore((s) => s.colorIdentity);
  return useMemo(() => validateDeck(entries, colorIdentity), [entries, colorIdentity]);
}
